import React from 'react'
import { Routes, Route } from 'react-router-dom'
import ScrollToTop from './components/ScrollToTop'
import Header from './components/Header'
import Footer from './components/Footer'

import HomePage from './pages/HomePage'
import BoatsPage from './pages/BoatsPage'
import MotorboatsPage from './pages/MotorboatsPage'
import MotorsailersPage from './pages/MotorsailersPage'
import SailboatsPage from './pages/SailboatsPage'
import BoatDetailPage from './pages/BoatDetailPage'
import ForespoergselPage from './pages/ForespoergselPage'
import SaelgDinBaadPage from './pages/SaelgDinBaadPage'
import ForsikringPage from './pages/ForsikringPage'
import SamarbejdspartnerePage from './pages/SamarbejdspartnerePage'
import OmOsPage from './pages/OmOsPage'
import KontaktPage from './pages/KontaktPage'
import NotFoundPage from './pages/NotFoundPage'
import ForbiddenPage from './pages/ForbiddenPage'
import LegacyRedirectPage from './pages/LegacyRedirectPage'

export default function App() {
  return (
    <>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen bg-slate-50 text-slate-800 selection:bg-[#2BABE3] selection:text-white">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/baade" element={<BoatsPage />} />
            <Route path="/motorbaade" element={<MotorboatsPage />} />
            <Route path="/motorsejlere" element={<MotorsailersPage />} />
            <Route path="/sejlbaade" element={<SailboatsPage />} />
            <Route path="/baad/:slug" element={<BoatDetailPage />} />
            <Route path="/forespoergsel" element={<ForespoergselPage />} />
            <Route path="/saelg-din-baad" element={<SaelgDinBaadPage />} />
            <Route path="/forsikring" element={<ForsikringPage />} />
            <Route path="/samarbejdspartnere" element={<SamarbejdspartnerePage />} />
            <Route path="/om-os" element={<OmOsPage />} />
            <Route path="/kontakt" element={<KontaktPage />} />
            <Route path="/403" element={<ForbiddenPage />} />
            <Route path="/:caseNumber" element={<LegacyRedirectPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </>
  )
}
